import store from '@/states/index.js'

import Inbox from '../InboxComponent.vue'

export default [
    {
        path: '/inbox',
        component: Inbox,
        name: 'inbox',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 3){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]